export default "__VITE_ASSET__Dhf5zm78__"